._ContentReviewStatusTag_u5daw_1 {
  margin-right: 0;
}